<template>
  <div class="hero-text" v-show="isReady">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 873.9 121.8"
      style="enable-background:new 0 0 873.9 121.8;"
      xml:space="preserve"
    >
      <g>
        <path
          ref="letterT"
          class="path"
          d="M0,8.1h77.9 M39,8.1v113.7"
        />

        <path
          ref="letterO"
          class="path"
          d="M196.7,61.1c0,27.6-22.4,50-50,50s-50-22.4-50-50s22.4-50,50-50S196.7,33.5,196.7,61.1z"
        />

        <path
          ref="letterM"
          class="path"
          d="M255.5,124.8l37-100l37,100"
        />

        <path
          ref="letterM2"
          class="path"
          d="M295.5,124.8l37-100l37,100"
        />

        <path
          ref="letterI"
          class="path"
          d="M398.3-0.9v122.7"
        />

        <path
          ref="letterA1"
          class="path"
          d="M491.3,87.8 h-46.8l24-64L491.3,87.8l14.2,37"
        />

        <g id="A-2" style="">
          <defs>
            <rect id="SVGID_1_" x="423" y="106.1" width="39.3" height="20.3"/>
          </defs>
          <clipPath id="SVGID_2_">
            <use xlink:href="#SVGID_1_" style="overflow:visible;"/>
          </clipPath>
          <path
            ref="letterA2"
            class="path"
            id="A-1_1_"
            style="clip-path:url(#SVGID_2_)"
            d="M430,127.8l24-64"
          />
        </g>

        <path
          ref="letterS"
          class="path"
          d="M531,97c0,0,34.3,36,71.3,0l-73-72.2c0,0,37.5-35.1,74,0"
        />

        <path
          ref="letterT2"
          class="path"
          d="M626,8.1h77.9 M665,8.1v113.7"
        />

        <path
          ref="letterO2"
          class="path"
          d="M822.7,61.1c0,27.6-22.4,50-50,50s-50-22.4-50-50s22.4-50,50-50C800.3,11.1,822.7,33.5,822.7,61.1z"
        />

        <line
          ref="line"
          class="path"
          x1="772.7"
          y1="64.1"
          x2="873.9"
          y2="64.1"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  props: {
    animate: {
      type: Boolean,
      default: false
    },
    isAnimatable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isReady: false
    }
  },
  watch: {
    animate () {
      if (this.animate && this.lineAnimation && this.lettersAnimation) {
        this.lineAnimation.play()
        this.lettersAnimation.play()
      }
    }
  },
  mounted () {
    if (!this.isAnimatable) {
      this.isReady = true
      return
    }

    const {
      letterT,
      letterO,
      letterM,
      letterM2,
      letterI,
      letterA1,
      letterA2,
      letterS,
      letterT2,
      letterO2,
      line
    } = this.$refs

    const targets = [
      letterT,
      letterO,
      letterM,
      letterM2,
      letterI,
      letterA1,
      letterA2,
      letterS,
      letterT2,
      letterO2
    ]

    this.lettersAnimation = anime({
      targets,
      delay: (_, i) => (i + 0.5) * 200,
      strokeDashoffset: [anime.setDashoffset, 0],
      strokeWidth: [15, 16],
      easing: 'easeInOutSine',
      duration: 750,
      autoplay: false
    })

    this.lineAnimation = anime.timeline({
      targets: line,
      autoplay: false,
      duration: 400,
      easing: 'easeInOutSine'
    })

    this.lineAnimation
      .add({
        x1: [0, 0],
        x2: [0, 150]
      })
      .add({
        x1: [0, 150],
        offset: '+=250'
      })
      .add({
        x1: [632, 632],
        x2: [632, 652],
        offset: '+=450'
      })
      .add({
        x1: [632, 652],
        offset: '+=125'
      })
      .add({
        x1: [772, 772],
        x2: [772, 873],
        offset: '+=300',
        complete: () => {
          this.$emit('complete')
        }
      })

    this.isReady = true
  }
}
</script>

<style lang="scss" scoped>
 .path {
    fill: none;
    stroke: #fff;
    stroke-width: 16px;
    will-change: stroke-dashoffset, stroke-dasharray;
 }
</style>



// WEBPACK FOOTER //
// src/components/HeroText.vue